<div class="alert-box__wrapper">
  <div class="alert-box__box">
    <div class="alert-box__inner-wrap" *ngIf="!showSpinner">
      <div class="alert-box__icon">
        <img src="assets/img/icon-{{type}}.svg" />
      </div>
      <p class="alert-box__message alert-box__message mb-40 mx-auto" [innerHTML]="messageLine"></p>
      <index-button (click)="buttonClickedHandler($event)" class="alert-box__action" size="full">{{buttonText}}</index-button>
    </div>
    <div class="alert-box__inner-wrap" *ngIf="showSpinner">
      <div class="k-loading-panel-mask"></div>
      <div class="k-loading-panel-wrapper">
        <div class="loader" style="text-align: center;">
          <i class="lin-loading-circle"></i>
          <p>{{ messageLine }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
